import apiClient from "../config/apiClient";
import { API_ENDPOINTS } from "../config/endpoints";

/**
 * Process a combined catering manual order (for multiple packages)
 * @param {Object} payload - Order processing payload
 * @param {string} payload.country_id - Country ID
 * @param {string} payload.customer_id - Customer ID
 * @param {string} payload.company_id - Company ID (0 for individual customers)
 * @param {number} payload.address_id - Address ID
 * @param {string} payload.payment_method_id - Payment method ID
 * @param {string} payload.delivery_charge - Delivery charge
 * @param {number} payload.order_sub_total_price - Order subtotal price
 * @param {string} payload.discount_price - Discount price
 * @param {number} payload.order_total_price - Order total price
 * @param {string} payload.currency - Currency (e.g., "KWD")
 * @param {string} payload.is_discount_applied - Whether discount is applied
 * @param {string} payload.promo_code - Promo code
 * @param {string} payload.comments - Order comments/notes
 * @param {boolean} payload.pay_later - Whether to pay later (Book Slot)
 * @param {boolean} payload.is_bilbayt - Whether paid via Bilbayt
 * @returns {Promise} API response with order details
 */
export const processCombinedCateringManualOrder = async (payload) => {
  try {
    console.log('Processing combined catering manual order with payload:', payload);
    const response = await apiClient.post(API_ENDPOINTS.PROCESS_COMBINED_CATERING_MANUAL_ORDER, payload);
    console.log('Combined catering manual order response:', response.data);
    return response.data;
  } catch (error) {
    console.error("Error processing combined catering manual order:", error);
    throw error;
  }
};

